{
  "version": 1,
  "asset_id": "3fe3350f-039b-4433-a05e-2ae7b825d26e",
  "project_id": "a59a3c70-54e7-4b71-a321-099d87b35b8c",
  "url": "/__l5e/assets-v1/3fe3350f-039b-4433-a05e-2ae7b825d26e/demo-sam.mp3",
  "r2_key": "a/v1/a59a3c70-54e7-4b71-a321-099d87b35b8c/3fe3350f-039b-4433-a05e-2ae7b825d26e/demo-sam.mp3",
  "original_filename": "demo-sam.mp3",
  "size": 823004,
  "content_type": "audio/mpeg",
  "created_at": "2026-08-13T11:34:31Z"
}
